<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <card class="custom-shadow-card-header">
        <station-gis @showHideLoading="showHideLoading"></station-gis>
      </card>
    </div>
  </div>
</template>

<script>
import StationGis from '../../Gis/Station/StationGis.vue';
import MixinLoading from 'src/mixins/mixin-loading';

export default {
  components: {
    StationGis,
  },
  mixins: [MixinLoading],
  data() {
    return {};
  },
};
</script>
